<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-sm-4"></div>
          <div class="col-sm-8 d-flex justify-content-end">
            <ts-input v-model="search" placeholder="Search" style="width: 300px;" />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table :columns="columns" :records="resources" :loading="loading">
        <template slot-scope="{ record }">
          <td>{{ record.vendor_name_kh }}</td>
          <td>{{ record.vendor_name_en }}</td>
          <td>{{ record.contact_no }}</td>
          <td>{{ record.contact_person }}</td>
          <td>{{ record.email }}</td>
          <td>{{ record.website }}</td>

          <td class="text-center">
            <a href="#" title="edit" class="text-primary mr-2" @click.prevent="edit(record)">
              <i class="fas fa-edit"></i>
            </a>

            <a href="#" title="delete" class="text-danger" @click="destroy(record)">
              <i class="fas fa-circle-notch spin spiner" v-if="record._deleting"></i>
              <i class="fas fa-trash" v-if="record._deleting == false"></i>
            </a>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData"> </ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'

export default {
  props: ['fetch'],
  name: 'vendor-profile-table',
  data() {
    return {
      loading: false,
      columns: [
        { name: 'name kh' },
        { name: 'name en' },
        { name: 'contact no' },
        { name: 'contact person name' },
        { name: 'email address' },
        { name: 'website' },
        { name: 'action', style: 'text-align:center; width:5%' }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('administration/vendorProfile', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.administration.vendorProfile.search
      },
      set(newValue) {
        this.$store.commit('administration/vendorProfile/SET_SEARCH', newValue)
        this.$store.commit('administration/vendorProfile/RESET_CURRENT_PAGE')
      }
    }
  },
  methods: {
    fetchData(attribute) {
      this.loading = true
      this.$store
        .dispatch('administration/vendorProfile/fetch')
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },
    edit(record) {
      this.$store.commit('administration/vendorProfile/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'vendor-profile-edit',
        params: { id: record.vendor_id }
      })
    },

    async destroy(record) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        record._deleting = true
        this.$store
          .dispatch('administration/vendorProfile/delete', record.vendor_id)
          .then(response => {
            record._deleting = false
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            record._deleting = false
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    fetch: function(value) {
      if (value) {
        this.fetchData()
        this.$emit('fetched')
      }
    },
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  }
}
</script>
